import { Box, Typography } from "@mui/material";
import ContactText from "../ContactText";
import {SxProps} from "@mui/system";
interface ErrorInfoProps {
    header?: string;
    description?: string;
    additionalInfo?: string;
    contactSales?: boolean;
    submitButton?: React.ReactNode;
}
const boxSx: SxProps = {
    display: "flex",
    flexDirection: "column",
    flex: 1,
};

const DEFAULT_HEADER = "Oops!";
const DEFAULT_DESCRIPTION = "Something went wrong.";

export default function ErrorInfo({
    header = DEFAULT_HEADER,
    description = DEFAULT_DESCRIPTION,
    additionalInfo,
    contactSales = false,
    submitButton
}: ErrorInfoProps) {
    return (
        <Box sx={boxSx}>
            <Typography variant="h2" gutterBottom color="error.main">
                {header}
            </Typography>

            <Typography variant="h5" gutterBottom>
                {description}
            </Typography>

            {additionalInfo && <Typography gutterBottom>
                {additionalInfo}
            </Typography>}

            <Typography gutterBottom>
                <ContactText contactSales={contactSales}/>
            </Typography>
            { submitButton }
        </Box>
    );
}
